import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";

import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Divider, Box, Grid, Typography } from "@mui/material";
import VendorrequirementCard from "../../../stories/Vendorrequirement/VendorrequirementCard";
import ClientEvaluationsList from "./ClientEvaluationsList";
import VendorLocationCard from "../../../stories/vendorLocationcard/VendorLocationCard";
import VendorCompleted from "../../../stories/VendorCompleted/VendorCompleted";
import VendorGeneralinformation from "./VendorGeneralinformation";
import VendorContractorperformance from "./VendorContractorperformance";
import VendorContactinformation from "./VendorContactinformation";
import EvaluationsDataEntry from "./EvaluationsDataEntry";
import VendorQuestios from "./VendorQuestios";

import axios from "../../../utils/fvAxios";
import apiinfo from "../../../utils/base-uri.json";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import Nodata from "../../Nodata/Nodata";

import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {},
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export default function VendorDetailsTab(props) {

  const { t } = useTranslation();

  const [shows, setShow] = useState(true);
  const [EntryEvaluation, setEntryEvaluation] = useState(true);
  const [RatingType, setRatingType] = useState("");
  const [pqLocations, setPqlocations] = useState([]);
  const [PQVendorCompleted, setPQVendorCompleted] = useState([]);
  const [question, setquestion] = React.useState([]);
  const [eriQuestionSections, setERIQuestionSections] = React.useState([]);
  const [count, setCount] = React.useState([]);
  const [contractorEvaluations, setContractorEvaluations] = React.useState([]);

  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");

  const [refreshDocs, setRefreshDocs] = React.useState(false);
  const [RecallEvalutions, setRecallEvalutions] = React.useState(false);
  const [loadingLocation, setLoadingLocation] = React.useState(true);
  async function GetPQLocations() {
    setLoadingLocation(true);
    const res = await axios.get(apiinfo.vendor.PQLocations + "pqId=" + PQID);
    res?.data?.data && setPqlocations(res?.data?.data);
    setRefreshDocs(false);
  }

  useEffect(() => {
    setLoadingLocation(false);
  }, [pqLocations]);
  async function PQVendorCompletedBy() {
    const res = await axios.get(apiinfo.vendor.PQVendorCompletedBy + "pqId=" + PQID);
    res?.data?.data && setPQVendorCompleted(res?.data?.data);
  }
  async function GetConfiguredQuestions() {
    const res = await axios.get(apiinfo.vendor.GetConfiguredQuestions + "pqId=" + PQID);
    res?.data?.data && setquestion(res?.data?.data);
  }
  async function VendorDetailERIQuestionSections() {
    const res = await axios.get(apiinfo.vendor.VendorDetailERIQuestionSections + "pqId=" + PQID);
    res?.data?.data && setERIQuestionSections(res?.data?.data);
    setCount(res?.data?.count);
  }

  async function ContractorEvaluations() {
    const res = await axios.get(apiinfo.vendor.ContractorEvaluations + "pqId=" + PQID);
    setContractorEvaluations(res?.data?.data);
    setRecallEvalutions(false);
  }
  useEffect(() => {
    if (refreshDocs == true) {
      GetPQLocations();
    }
  }, [refreshDocs]);

  useEffect(() => {
    if (RecallEvalutions == true) {
      ContractorEvaluations();
    }
  }, [RecallEvalutions]);

  useEffect(() => {
    VendorDetailERIQuestionSections();
    GetPQLocations();
    PQVendorCompletedBy();
    GetConfiguredQuestions();
    ContractorEvaluations();
  }, [props.Refresh]);

  const groupByCategory = Object.entries(pqLocations?.reduce((group, product) => {
    const { clientName } = product;
    group[clientName] = group[clientName] ?? [];
    group[clientName].push(product);
    return group;
  }, {}));

  const RatingTypeChange = (value, id) => {
    setEntryEvaluation(value);
    setRatingType(id);
  }


  return (
    <>
      <div style={{ display: shows && EntryEvaluation ? "block" : "none" }}>

        {/* Comments */}
        <Box border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec" className="mt-2 mb-3" sx={{ padding: "10px", background: "#fff" }} hidden={!props?.COMMENT || props?.Check == true}>
          <span className="text-muted mx-2 mt-1" style={{ fontWeight: "bolder", fontSize: "larger", marginTop: "5px" }}>{t('VendorDetails.label35')}</span>
          <Divider sx={{ backgroundColor: "#667085;", marginTop: "5px", height: "2px", display: !props?.COMMENT || props?.Check == true ? "none" : "block" }} />
          <span className="text-muted mx-2 mt-1" style={{ marginTop: "5px" }}>{props?.COMMENT}</span>
          <br />
        </Box>

        {/* Questions */}
        <VendorQuestios questions={question} />

        {/*Performance Compared to Requirements */}
        <Box border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec" className="mt-2" sx={{ padding: "20px", display: (count === 0) ? "none" : "block", backgroundColor: "#fff" }} >
          <span
            className="text-muted"
            style={{ color: "#3E4A62", fontWeight: "bolder", fontSize: "larger" }}
          >
            {t('VendorDetails.label0')}

          </span>
          <Divider sx={{ backgroundColor: "#667085", height: "2px", marginTop: "5px" }} />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {eriQuestionSections.map((r, i) => (
              <Grid item xs={12} sm={3} md={3} key={i} sx={{ marginTop: "20px" }}>
                <VendorrequirementCard sections={r} PQSTID={props?.PQSTID} />
              </Grid>
            ))}
          </Grid>
          <br />
        </Box>

        {/* Location */}
        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          className="mt-2"
          sx={{ padding: "10px", background: "#fff" }}
          hidden={!pqLocations || props?.HiddeneLocations}
        >
          <span
            className="text-muted mx-2 mt-1"
            style={{
              fontWeight: "bolder",
              fontSize: "larger",
              marginTop: "5px",
            }}
          >
            {t("VendorDetails.label1")}
          </span>
          <Divider
            sx={{
              backgroundColor: "#667085;",
              marginTop: "5px",
              height: "2px",
              display: !pqLocations ? "none" : "block",
            }}
            hidden={!pqLocations}
          />
          <Box sx={{ flexGrow: 1, paddingLeft: 1 }}>
            {groupByCategory?.length > 0 ? (
              groupByCategory?.map((r, i) => (
                <VendorLocationCard
                  key={i}
                  Name={r[0]}
                  Data={r[1]}
                  refresh={setRefreshDocs}
                  Refresh={refreshDocs}
                />
              ))
            ) : loadingLocation ? (
              <LoadingSpinner />
            ) : (
              <Nodata />
            )}
          </Box>
          <br />
        </Box>

        {/* Contact information */}
        {props?.details?.PqVendorOrgDetails && <VendorGeneralinformation
          details={props?.details?.PqVendorOrgDetails}
          add={props?.details?.address}
          contact={props?.details?.contactInformation}
        />}

        {/* Vendor Contacts */}
        {props?.contact && <VendorContactinformation contact={props?.contact} details={props.details} />}

        {/* completed by */}
        <Box border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec" className="mt-3" sx={{ padding: "10px", backgroundColor: "#fff" }}>
          <span className="text-muted mx-2 mt-1 " style={{ fontWeight: "bolder", fontSize: "larger" }}>{t('VendorDetails.label2')}</span>
          <Divider sx={{ backgroundColor: "#667085", height: "2px" }} />
          <Box sx={{ flexGrow: 1, paddingLeft: 1 }}>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              {PQVendorCompleted.map((r, i) => (
                <Grid item xs={12} sm={3} md={3} key={i}>
                  <VendorCompleted
                    compleated={r}
                    start={props.details.PrequalificationDetails}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          <br />
        </Box>

        {/* Contractor Performance Evaluation */}
        <VendorContractorperformance setShow={setShow} RatingTypeChange={RatingTypeChange} />
      </div >

      <div style={{ display: shows ? "none" : "block" }}>
        {contractorEvaluations && <ClientEvaluationsList evalaution={contractorEvaluations} Recall={setRecallEvalutions} evalutedVendors={props?.evalutedVendors} Reset={props?.Reset} Refresh={props?.Refresh} />}
      </div>


      <div style={{ display: EntryEvaluation ? "none" : "block" }}>
        <EvaluationsDataEntry RatingTypeChange={RatingTypeChange} PQCLIENTID={props?.PQCLIENTID} RatingType={RatingType} evalutedVendors={props?.evalutedVendors} Reset={props?.Reset} Refresh={props?.Refresh} />
      </div>

    </>
  );
}